module.exports = __webpack_public_path__ + "static/wiz5-efc6e69421a0f10f151a6b14bdfff021.jpg";